import { useMemo } from 'react';
import { useScheduler } from '../SchedulerContext';
import {
  validateRequiredInfo,
  type RequiredInfoValidationResult,
} from './requiredInfoValidation';

/**
 * Reads the required-info question set for the current cart out of scheduler
 * context and reports what is still unanswered.
 *
 * Every gate in the funnel — the More Information step's Continue button, the
 * top stepper, the header Next button, the summary bar, the Schedule Now button
 * — must derive from this hook so they can never disagree about whether the
 * customer is allowed to move on.
 *
 * Tolerates a partially populated context (missing catalog ⇒ nothing required),
 * which keeps the non-funnel consumers of `SchedulerProvider` and the existing
 * unit tests working.
 */
export function useRequiredInfoValidation(): RequiredInfoValidationResult {
  const { selectedServiceIds, services, allRequiredInfo, requiredInfoValues } =
    useScheduler();

  return useMemo(
    () =>
      validateRequiredInfo({
        selectedServiceIds: selectedServiceIds ?? [],
        services: services ?? [],
        allRequiredInfo: allRequiredInfo ?? [],
        values: requiredInfoValues ?? [],
      }),
    [selectedServiceIds, services, allRequiredInfo, requiredInfoValues]
  );
}
